export default [
    {
        Link: 'https://serverlessreact.dev/',
        Title: 'ServerlessReact.dev',
    },
] 